import type { components } from '@pba/types-openapi-client';
import type { ConfigRequest } from '@pba/utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

export type GetUsersParams = {
  cursor?: string;
  exclude_community_id?: string;
  exclude_program_id?: string;
  limit?: number;
  scope: 'all';
  search?: string;
};

export const getUsers = async ({ config }: ConfigRequest<GetUsersParams>) =>
  apiClient.get<Array<components['schemas']['UserList']>, ApiClientResponse<Array<components['schemas']['UserList']>>>(
    routes.user.autocomplete,
    config,
  );
